// =====================================================================
// «NO FUI YO» · ESTABILIDAD Parte D · D5
// =====================================================================
// Se abre desde el enlace del aviso de entrada nueva (correo o Telegram):
// `/app?ir=no-fui-yo&t=<token>&c=<empresa>`. Funciona SIN sesión, que es
// todo su sentido: quien lo pulsa puede no poder entrar.
//
// UN TOQUE MÁS, Y ES A PROPÓSITO. Algunos programas de correo abren los
// enlaces solos para revisarlos; si el enlace cerrara las sesiones al
// abrirse, un revisor automático las cerraría sin que nadie lo pidiera.
// Así que el enlace enseña esta pantalla y el botón hace el cierre.
import { useState } from 'react';
import { ShieldAlert, Loader2, CheckCircle2 } from 'lucide-react';
import { api } from '../api';
import Ayuda from '../ui/Ayuda';

export default function NoFuiYo({ token, empresa }) {
  const [estado, setEstado] = useState('pregunta');
  const [respuesta, setRespuesta] = useState(null);
  const [error, setError] = useState(null);

  async function cerrarTodo() {
    setEstado('cerrando');
    setError(null);
    try {
      setRespuesta(await api.post('/seguridad/no-fui-yo', { token, empresa }));
      setEstado('hecho');
    } catch (e) {
      setError(e.message || 'No se pudo cerrar las sesiones. Revisa la conexión y vuelve a pulsar.');
      setEstado('pregunta');
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="mx-auto max-w-md space-y-4 rounded-2xl border border-gray-200 bg-white p-5">
        <div className="flex items-start gap-3">
          <ShieldAlert className="h-7 w-7 shrink-0 text-red-600" aria-hidden="true" />
          <div>
            <h1 className="text-xl font-semibold text-gray-900">¿No fuiste tú?</h1>
            <p className="text-sm text-gray-600">Cierra de un toque todas las sesiones abiertas de tu cuenta.</p>
          </div>
        </div>
        <Ayuda id="seguridad.no_fui_yo.pantalla" />

        {estado !== 'hecho' ? (
          <>
            <button type="button" onClick={cerrarTodo} disabled={estado === 'cerrando'}
                    className="inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-lg bg-red-600 px-4 py-3 text-base font-semibold text-white disabled:opacity-60">
              {estado === 'cerrando' && <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />}
              No fui yo: cerrar todas las sesiones
            </button>
            <Ayuda id="seguridad.no_fui_yo.boton" />
            {error && <p role="alert" className="rounded-lg border border-red-200 bg-red-50 p-2.5 text-sm text-red-700">{error}</p>}
            <a href="/app" className="block text-center text-sm text-gray-600 underline">Sí fui yo: ir a TEGO</a>
          </>
        ) : (
          <div role="status" className="space-y-3">
            <p className="flex items-center gap-2 font-medium text-green-800">
              <CheckCircle2 className="h-5 w-5" aria-hidden="true" /> Todas las sesiones quedaron cerradas.
            </p>
            {respuesta?.contexto && (
              <p className="text-sm text-gray-700">
                La entrada que se avisó: {respuesta.contexto.aparato}, desde {respuesta.contexto.lugar}, el {respuesta.contexto.cuando}.
              </p>
            )}
            <p className="text-sm text-gray-700">{respuesta?.mensaje}</p>
            <a href="/app?ir=login" className="inline-flex min-h-11 items-center rounded-lg bg-[var(--color-marca)] px-4 py-2 text-sm font-semibold text-white">
              Entrar y cambiar mi contraseña
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
